import React from "react";
import { CompanyWithPackages, PolicyPackage } from "../../interfaces/altair";
import './package-selection.scss';

const getCompanyLogo = (companyNameEn: string): string | null => {
  const normalized = companyNameEn.trim().toLowerCase();
  if (normalized.includes("gig")) return "/new/gig-logo.png";
  if (normalized.includes("misr") && normalized.includes("insurance")) {
    return "/new/MIC-logo.png";
  }
  return null;
};
interface PackageSelectionProps {
  /** Whether to render the package selection block (typically flowStep === "package_selection") */
  visible: boolean;
  companies: CompanyWithPackages[];
  selectedPackageCode: string;
  onSelectPackage: (pkg: PolicyPackage) => void;
  onConfirm: (pkg: PolicyPackage) => void;
  /** @deprecated No longer used — clicking a package immediately confirms it */
  _unused?: never;
}

export const PackageSelection: React.FC<PackageSelectionProps> = ({
  visible,
  companies,
  selectedPackageCode,
  onSelectPackage,
  onConfirm,
}) => {
  const hasPackages = companies.some(
    (company) => Array.isArray(company.companyPackages) && company.companyPackages.length > 0
  );

  if (!visible || companies.length === 0 || !hasPackages) {
    return null;
  }

  const handlePackageClick = (pkg: PolicyPackage) => {
    // Highlight the card first (visual feedback), then immediately confirm
    onSelectPackage(pkg);
    onConfirm(pkg);
  };

  // Find the currently selected package, if any
  const selectedPackage: PolicyPackage | null = (() => {
    if (!selectedPackageCode) return null;
    for (const company of companies) {
      const pkg = company.companyPackages.find(
        (p: PolicyPackage) => p.packageCode === selectedPackageCode
      );
      if (pkg) return pkg;
    }
    return null;
  })();

  return (
    <section className="package-selection-page card-width" dir="rtl">
      {hasPackages && (
        <h3 className="package-selection-title">أختر باقة التأمين</h3>
      )}
      <div className="package-selection-scroll-list">
        {companies.map((company, companyIndex) => {
          if (!Array.isArray(company.companyPackages) || company.companyPackages.length === 0) {
            return null;
          }

          return (
          <div
            key={`company-${companyIndex}`}
            className="package-selection-company-group"
          >
            <div className="package-selection-company-title-row">
              {getCompanyLogo(company.companyNameEn) && (
                <img
                  src={getCompanyLogo(company.companyNameEn) || ""}
                  alt={company.companyNameEn}
                  className="package-selection-company-logo"
                />
              )}
              <h4 className="package-selection-company-title">
                {company.companyNameAr} ({company.companyNameEn})
              </h4>
            </div>
            <div className="package-selection-company-packages">
              {company.companyPackages.map(
                (pkg: PolicyPackage, pkgIndex: number) => (
                  <button
                    key={
                      pkg.packageCode
                        ? `pkg-${pkg.packageCode}`
                        : `pkg-${companyIndex}-${pkgIndex}`
                    }
                    onClick={() => handlePackageClick(pkg)}
                    className={`package-card ${
                      selectedPackageCode === pkg.packageCode
                        ? "package-card--selected"
                        : ""
                    }`}
                  >
                    {selectedPackageCode === pkg.packageCode && (
                      <span className="package-card__chip">الأشهر</span>
                    )}
                    <span className="package-card__name">
                      {pkg.packageTypeAr}
                      <br />
                      <span className="package-card__name-en">
                        ({pkg.packageTypeEn})
                      </span>
                    </span>
                    <span className="package-card__price-wrap">
                        <span className="package-card__period">سنه/</span>
                      <span className="package-card__price">
                        
                        {pkg.totalpremium !== undefined &&
                        pkg.totalpremium !== null
                          ? pkg.totalpremium.toLocaleString("en-US")
                          : "-"}
                      </span>
                    </span>
                  </button>
                )
              )}
            </div>
          </div>
          );
        })}
      </div>
    </section>
  );
};
